import { useContext, useEffect, useState } from "react";
import { useSelector } from "react-redux";
import Spinner from "../../../../../common/spinner";
import Toast from "../../../../../common/toast";
import apiCall from "../../../../../../apicall";
import { JobDetailsContext } from "../job-detail1";

function AssignJobConfirmation({
  selectedTrustedWorkerEmployee,
  fetchTrustedWorkerEmployeeList,
  buttonType
}) {
  const { role_type } = useSelector((state) => state.menu);
  const { jobDetailsInfo, getJobDetailsData } =
    useContext(JobDetailsContext);
  const { TOKEN } = useSelector((state) => state.menu);
  const [isLoading, setIsLoading] = useState(false);
  const [errSuccessMesg, setErrSuccessMsg] = useState({
    message: "",
    status: "error",
  });
  const [ isAdminRole ] = useState(role_type?.includes("ROLE_OPENSTAFF_ADMIN") ||
  role_type?.includes("ROLE_OPENSTAFF_FINANCIAL_ADMIN"));
  const [showError, setShowError] = useState({
    profession: false,
    jobType: selectedTrustedWorkerEmployee?.isPrivateEmployee ? (jobDetailsInfo?.isEmployeeOnly !== selectedTrustedWorkerEmployee?.isPrivateEmployee) : selectedTrustedWorkerEmployee?.isTrustedWorker ? (jobDetailsInfo?.isTrustedWorkerOnly !== selectedTrustedWorkerEmployee?.isTrustedWorker) : true
  });
  const [isTextLoading, setIsTextLoading] = useState(false);


  const handleClosePopup = () => {
    const ConfirmationBackDrop = document.getElementById(
      "modalBackdropAssignJob"
    );
    const ConfirmationPopupModal = document.getElementById("assign_job_popup");

    if (ConfirmationPopupModal) {
      ConfirmationBackDrop?.classList.remove("modal-backdrop", "show");
      ConfirmationPopupModal?.classList.remove("show");
      ConfirmationPopupModal.style.display = "none";
    }
  };

  const handleAssignJobToTrustedWorkerEmployee = async (applicantId, item) => {
    try {
      setIsLoading(true);
      const api =
        buttonType === "assign"
          ? isAdminRole ? `openstaff/jobs/${jobDetailsInfo?.id}/applyAndHire/${applicantId}`
          : `institutions/jobs/${jobDetailsInfo?.id}/applyAndHire/${applicantId}`
          : buttonType === "invite"
          ? isAdminRole ? `openstaff/jobs/${jobDetailsInfo?.id}/inviteEmployees/${applicantId}`
          : `institutions/jobs/${jobDetailsInfo?.id}/inviteEmployees/${applicantId}`
          : buttonType === "apply"
          ?`institutions/jobs/${jobDetailsInfo?.id}/applyTrustedCompanyJobs/${applicantId}`
          : "";

      const inviteTrustedWorkerResponse = await apiCall(
        api,
        "POST",
        null,
        TOKEN
      );

      if (inviteTrustedWorkerResponse?.status === 200) {
        setErrSuccessMsg({
          message: `${item?.firstName} ${item?.lastName} has been ${buttonType === "assign" ? 'assign' : buttonType === "invite" ?  'invited' : "applied"} for ${jobDetailsInfo?.jobTitle}.`,
          status: true,
        });

        await handleClosePopup();
        const jobDetails = await getJobDetailsData();
        await fetchTrustedWorkerEmployeeList();
        // await getAppliedApplicantsList();
        if(jobDetails?.jobStatus === 'eAccepted'){
          document.body.style.overflow = "unset";
          document.body.style.paddingRight = "0";
        }
        console.log("jobdetailsinfooo", jobDetails)
      } else if (inviteTrustedWorkerResponse?.response?.status == 401) {
        setErrSuccessMsg({
          message: "Your session has been expired!!",
          status: false,
        });
      } else {
        setErrSuccessMsg({
          message: inviteTrustedWorkerResponse?.response?.data?.errorMessage,
          status: false,
        });
      }
    } catch (err) {
      console.log("errrrr", err)
      setErrSuccessMsg({
        message: "Network Error",
        status: false,
      });
    } finally {
      setIsLoading(false);
    }
  };

const fetchJobSeekerProfession = async () => {
  try {
    setIsTextLoading(true);
    const professionResponse = await apiCall(
      `${selectedTrustedWorkerEmployee?.id}/getAdditionalProfessions`,
      "GET",
      null,
      TOKEN
    );
    if (professionResponse?.status === 200 && professionResponse?.data?.length > 0) {
      const profession = professionResponse?.data?.map((val) => val?.profession);
      const isPresent = profession?.includes(jobDetailsInfo?.jobPosition);

      const jobType =
        selectedTrustedWorkerEmployee?.isPrivateEmployee
          ? jobDetailsInfo?.isEmployeeOnly !== selectedTrustedWorkerEmployee?.isPrivateEmployee
          : selectedTrustedWorkerEmployee?.isTrustedWorker
          ? jobDetailsInfo?.isTrustedWorkerOnly !== selectedTrustedWorkerEmployee?.isTrustedWorker
          : true;

      setShowError((prev) => ({
        ...prev,
        jobType,
        ...(isPresent ? {} : { profession: true }),
      }));
    }
  } catch (error) {
    console.error("Error fetching professions:", error);
  }finally{
    setIsTextLoading(false);
  }
};

  
    useEffect(() => {
      if(selectedTrustedWorkerEmployee?.id && isAdminRole){
        fetchJobSeekerProfession();
      }
    },[selectedTrustedWorkerEmployee?.id]);

  return (
    <>
      <div
        className="modal fade twm-sign-up"
        id="assign_job_popup"
        aria-hidden="true"
        aria-labelledby="sign_up_popupLabel"
        tabIndex={-1}
      >
        <div className="modal-dialog modal-dialog-centered">
          <div className="modal-content">
            <div className="modal-header">
             <h2 className="modal-title" id="sign_up_popupLabel">
                {isTextLoading ? (
                  <Spinner />
                ) : (
                  <>
                    {showError?.profession && isAdminRole && (
                      <p style={{ color: "orange", fontSize: "14px", margin: 0 }}>
                        WARNING: {selectedTrustedWorkerEmployee?.firstName}{" "}
                        {selectedTrustedWorkerEmployee?.lastName} does not have{" "}
                        {jobDetailsInfo?.jobPosition} as one of their saved professions.
                      </p>
                    )}

                    {showError?.jobType && isAdminRole && (
                      <p style={{ color: "orange", fontSize: "14px", margin: 0 }}>
                        WARNING: {buttonType} {selectedTrustedWorkerEmployee?.firstName}{" "}
                        {selectedTrustedWorkerEmployee?.lastName} is a(n){" "}
                        {selectedTrustedWorkerEmployee?.isPrivateEmployee
                          ? "employee"
                          : selectedTrustedWorkerEmployee?.isTrustedWorker
                          ? "trusted worker"
                          : "public worker"}
                        . {jobDetailsInfo?.jobTitle} is not accepting{" "}
                        {selectedTrustedWorkerEmployee?.isPrivateEmployee
                          ? "employee"
                          : selectedTrustedWorkerEmployee?.isTrustedWorker
                          ? "trusted worker"
                          : "public worker"}
                        .
                      </p>
                    )}

                    <p style={{ marginTop: "6px" }}>
                      Would you like to {buttonType}{" "}
                      {selectedTrustedWorkerEmployee?.firstName}{" "}
                      {selectedTrustedWorkerEmployee?.lastName} to{" "}
                      {jobDetailsInfo?.jobTitle}?
                    </p>
                  </>
                )}
              </h2>
              <button
                type="button"
                className="btn-close"
                onClick={() => handleClosePopup()}
              />
            </div>
            <div className="modal-footer">
              <button
                type="button"
                className="btn btn-success"
                onClick={() =>
                  handleAssignJobToTrustedWorkerEmployee(
                    selectedTrustedWorkerEmployee?.applicantId,
                    selectedTrustedWorkerEmployee
                  )
                }
              >
                {isLoading ? <Spinner /> : "Yes"}
              </button>
              <button
                type="button"
                className="btn btn-secondary"
                // data-bs-dismiss="modal"
                onClick={() => handleClosePopup()}
              >
                No
              </button>
            </div>
          </div>
        </div>
      </div>
      <div
        id="modalBackdropAssignJob"
        className="fade show"
        style={{ zIndex: "1" }}
      ></div>

      {errSuccessMesg?.message !== "" ? <Toast message={errSuccessMesg} /> : ""}
    </>
  );
}

export default AssignJobConfirmation;
